"use client";

import Link from 'next/link';
import Image from 'next/image';
import type { ReactNode } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface AuthShellProps {
  title: string;
  description: string;
  footer?: ReactNode;
  children: ReactNode;
}

export function AuthShell({ title, description, footer, children }: AuthShellProps) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-secondary/50 px-4 py-12">
      <Card className="mx-auto w-full max-w-md">
        <CardHeader className="items-center text-center">
          <Link href="/" className="flex items-center gap-2 mb-4" prefetch={false}>
            <span className="relative block h-[42px] w-[150px]">
              <Image
                src="/logo/Moonitor-Black-Bg.png"
                alt="Moonitor Logo"
                fill
                sizes="150px"
                className="object-contain"
                fetchPriority="high"
                loading="eager"
              />
            </span>
          </Link>
          <CardTitle className="text-2xl font-headline">{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent>
          {children}
          {footer ? <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div> : null}
        </CardContent>
      </Card>
    </div>
  );
}
